export const isIOS = () => {
  if (typeof window !== 'undefined') {
    return navigator && navigator?.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  }
  return false;
};

/**
 * Determine if user is using a device with a touch-screen
 */
export const isTouchScreen = (): boolean => {
  if (typeof window !== 'undefined') {
    return !document.body.classList.contains('no-touch');
  } else {
    return false;
  }
};

/**
 * The app target in which this instance of the web app is running.
 */
export const AppTargets = {
  // A web browser
  WEB: 'Web',

  // The native iOS app
  IOS: 'iOS',

  // React Native app for Android, and legacy iOS client
  REACT_NATIVE: 'ReactNative',
} as const;

/**
 * A specific app target
 */
export type AppTarget = (typeof AppTargets)[keyof typeof AppTargets];

/**
 * Get the current app target by inspecting installed window objects.
 * @returns The current app target
 */
export const getAppTarget = (): AppTarget => {
  if (BROWSER && window.iOS) {
    return 'iOS';
  }

  if (BROWSER && window.ReactNative) {
    return 'ReactNative';
  }

  return 'Web';
};

/**
 * @returns Whet the web app running in any native app?
 */
export const isInApp = () => {
  const targets: AppTarget[] = ['ReactNative', 'iOS'];
  return targets.includes(getAppTarget());
};

/**
 * @returns Whether the web app running in the iOS native app
 */
export const isIOSNative = () => {
  return getAppTarget() === 'iOS';
};

/**
 * The app store ID for the iOS consumer app. Used for Apple platform integrations.
 */
export const IOS_CONSUMER_APP_ID = '1369347408';
